export const convertToTranslatedKeys = (t, i18KeyedObject) => (
  Object.fromEntries(
    Object
      .keys(i18KeyedObject)
      .map(key => [t(key), i18KeyedObject[key]])
  )
);
